import MobileDetect from 'mobile-detect';

import { spanizeHeadings, spanizeSvgContentHeadings } from './js/spanizer';
import { initScrollAnimation, initAppearAnimation } from './js/animation';

const md = new MobileDetect(window.navigator.userAgent);
const isMobile = md.mobile() !== null;

spanizeHeadings();
spanizeSvgContentHeadings();
initAppearAnimation();
initScrollAnimation(isMobile);
